/** Thrown when the user cancels an upload after a duplicate prompt. Cleanup still runs. */
export class UploadCancelledError extends Error {
  constructor(message = 'This file was not uploaded.') {
    super(message);
    this.name = 'UploadCancelledError';
  }
}
